import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white website-visitors" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-sm-25 p-lg-30 letter-spacing" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "mb-lg-15 d-sm-flex align-items-center justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "card-title fw-bold mb-0" }, "STATS VENTES PAR MOIS")
], -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  id: "websiteVisitorsChart",
  class: "chart"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Chargement des données... "))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_apexchart, {
              type: "bar",
              height: "385",
              options: _ctx.websiteVisitorsChart,
              series: _ctx.website
            }, null, 8, ["options", "series"])
          ]))
    ])
  ]))
}